import React from 'react'
import isEmpty from 'lodash/isEmpty'
import {
  Grid,
  Typography,
  FormControl,
  FormLabel,
  TextField,
} from '@the-platform-group/component-library'
import { ModalContent, ModalTitle, ModalActions } from '@the-platform-group/component-library/Modal'
import { Button } from '@the-platform-group/component-library/Button'
import AttachFilesButton from '../Requests/components/AttachFilesButton'

import useCustomerRequestInstructionsModalForm from './hooks/useCustomerRequestInstructionsModalForm'
import useRequestFormFileUpload from '../Requests/hooks/useRequestFormFileUpload'
import UploadedFilesDisplay from '../components/UploadedFilesDisplay'

const CustomerRequestInstructionsModalForm = ({ customer, handleClose, instructionsToEdit }) => {
  const {
    params,
    setParams,
    handleInstructionChange,
    isEditing,
    isSubmitting,
    handleSubmit,
  } = useCustomerRequestInstructionsModalForm(customer, instructionsToEdit)

  const {
    pendingFiles,
    uploadedFiles,
    handleFileSelect,
    handleFileRemove,
    resetFileState,
  } = useRequestFormFileUpload({
    initialFiles: isEditing ? instructionsToEdit.filePaths : [],
    getUrlFieldValues: () => params.urls,
    setUrlFieldValue: value => setParams({ ...params, urls: value }),
  })

  const { instructions } = params

  return (
    <>
      <ModalTitle title="Add Instructions" />
      <ModalContent>
        <Typography variant="body2" paragraph>
          Add any notes, special instructions or preferences shared by the customer either via email
          or within the request description. If any supporting attachments were provided, please
          upload those as well.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel>Customer Name</FormLabel>
              <TextField disabled fullWidth margin="normal" label={customer.name} />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel>Instructions</FormLabel>
              <TextField
                fullWidth
                multiline
                rows={5}
                value={instructions}
                margin="normal"
                placeholder="Add instructions"
                onChange={handleInstructionChange}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <UploadedFilesDisplay
              uploadedFiles={uploadedFiles}
              pendingFiles={pendingFiles}
              onFileRemove={handleFileRemove}
            />
          </Grid>
        </Grid>
      </ModalContent>
      <ModalActions sx={{ mx: 2, py: 2 }}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <AttachFilesButton
              onFileSelect={handleFileSelect}
              disabled={pendingFiles?.length > 0}
            />
          </Grid>
          <Grid item>
            <Grid container spacing={1}>
              <Grid item>
                <Button onClick={_ => handleClose(resetFileState)} variant="text">
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => handleSubmit(handleClose, resetFileState)}
                  isLoading={isSubmitting || !isEmpty(pendingFiles)}
                >
                  {isEditing ? 'Update' : 'Add'}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ModalActions>
    </>
  )
}

export default CustomerRequestInstructionsModalForm
